[
  
  /* pumps state and alarms */
  
  {
    name: "parallaxPumpAcidLamp",
    description: "Acid pump running",
    when: ctx =>
      ctx.devices.parallaxPumpAcid &&
      ctx.devices.parallaxPumpAcid.sp > 0,
    state: "run"
  },

  {
    name: "parallaxPumpBaseLamp",
    description: "Base pump running",
    when: ctx =>
      ctx.devices.parallaxPumpBase &&
      ctx.devices.parallaxPumpBase.sp > 0,
    state: "run"
  },

  {
    name: "parallaxPumpFeedLamp",
    description: "Feed pump running",
    when: ctx =>
      ctx.devices.parallaxPumpFeed &&
      ctx.devices.parallaxPumpFeed.sp > 0,
    state: "run"
  },

  {
    name: "parallaxPumpAntifoamLamp",
    description: "Antifoam pump running",
    when: ctx =>
      ctx.devices.parallaxPumpAntifoam &&
      ctx.devices.parallaxPumpAntifoam.sp > 0,
    state: "run"
  },
  
  /* agitation state and alarms */

  {
    name: "stirringLamp",
    description: "Stirring running",
    when: ctx =>
      ctx.devices.stirring &&
      ctx.devices.stirring.sp > 0,
    state: "run"
  },
  
  /* thermostat state and alarms */

  {
    name: "thermostatLamp",
    description: "Thermostat running",
    when: ctx =>
      ctx.devices.thermostat &&
      ctx.devices.thermostat.percentage > 0,
    state: "run"
  },
  
  {
    name: "thermostatLamp",
    description: "Thermostat control fail",
    when: ctx =>
      ctx.measurements.length >= 5 &&
      ctx.measurements.slice(-5).every(x =>
        x.thermostat &&
        (x.thermostat.percentage > 0 && x.thermostat.power < 1)
      ),
    state: "fault"
  },
  
  /* MFC air state and alarms */

  {
    name: "iqflowLamp",
    description: "Airation running",
    when: ctx =>
      ctx.devices.iqflow &&
      ctx.devices.iqflow.sp > 0,
    state: "run"
  },

  {
    name: "iqflowLamp",
    description: "Airflow control fail",
    when: ctx =>
      ctx.measurements.length >= 10 &&
      ctx.measurements.slice(-10).every(x =>
        x.iqflow &&
        Math.abs(x.iqflow.sp - x.iqflow.pv) > 1
      ),
    state: "fault"
  },
  
  /* Temperature control state and alarms */
  
  {
    name: "temperatureControlLamp",
    description: "Temp control active",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.targetTemperature),
    state: "run"
  },
  
  {
    name: "temperatureControlLamp",
    description: "Temp sensor value invalid",
    when: ctx =>
      ctx.measurements.length >= 3 &&
      ctx.measurements.slice(-3).every(x =>
        x.ezortdSensor &&
        (x.ezortdSensor.value < 0 || x.ezortdSensor.value > 100)
      ),
    state: "fault"
  },

  {
    name: "temperatureControlLamp",
    description: "Temperature control deviation",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.targetTemperature) &&
      ctx.fermentation.inoculationDate &&
      ctx.measurements.length >= 10 &&
      ctx.measurements.slice(-10).every(x =>
        x.ezortdSensor &&
        Math.abs(x.ezortdSensor.value - ctx.fermentation.targetTemperature) > 1
      ),
    state: "fault"
  },
  
  /* pH control state and alarms */
  
  {
    name: "pHControlLamp",
    description: "pH control active",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.targetPH),
    state: "run"
  },
  
  {
    name: "pHControlLamp",
    description: "pH sensor value invalid",
    when: ctx =>
      ctx.measurements.length >= 3 &&
      ctx.measurements.slice(-3).every(x =>
        x.ezophSensor &&
        (x.ezophSensor.value < 0 || x.ezophSensor.value > 14)
      ),
    state: "fault"
  },

  {
    name: "pHControlLamp",
    description: "pH control deviation",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.targetPH) &&
      ctx.fermentation.inoculationDate &&
      ctx.measurements.length >= 10 &&
      ctx.measurements.slice(-10).every(x =>
        x.ezophSensor &&
        Math.abs(x.ezophSensor.value - ctx.fermentation.targetPH) > 0.2
      ),
    state: "fault"
  },
  
  /* pO2 control state and alarms */
  
  {
    name: "pO2ControlLamp",
    description: "pO2 control active",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.oxygenLevel),
    state: "run"
  },
  
  {
    name: "pO2ControlLamp",
    description: "pO2 sensor value invalid",
    when: ctx =>
      ctx.measurements.length >= 3 &&
      ctx.measurements.slice(-3).every(x =>
        x.ezophSensor &&
        (x.visifermdo.value < 0 || x.visifermdo.value > 150)
      ),
    state: "fault"
  },  

  {
    name: "pO2ControlLamp",
    description: "pO2 control deviation",
    when: ctx =>
      ctx.fermentation &&
      Number.isFinite(ctx.fermentation.oxygenLevel) &&
      ctx.fermentation.inoculationDate &&
      ctx.measurements.length >= 10 &&
      ctx.measurements.slice(-10).every(x =>
        x.ezodoSensor &&
        Math.abs(x.visifermdo.value - ctx.fermentation.oxygenLevel) > 5
      ),
    state: "fault"
  }
   
]